import DatePicker from "@/components/DatePicker";
import Field from "@/components/Field";
import { DEFAULT_DATE_FORMAT } from "@/constants";
import { parse } from "date-fns";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useProjectSchedulesContext } from "../ProjectSchedulesContext";

interface DateRangeFieldProps {
  required?: boolean;
  disabled?: boolean;
}

const DateRangeComponent = ({
  required = false,
  disabled = false,
}: DateRangeFieldProps) => {
  const { t } = useTranslation();
  const { projectStartDate, projectEndDate } = useProjectSchedulesContext();

  const datePickerProps = useMemo(() => {
    if (
      disabled ||
      !(projectStartDate instanceof Date) ||
      !(projectEndDate instanceof Date)
    ) {
      return;
    }
    return {
      disabled: {
        before: projectStartDate,
        after: projectEndDate,
      },
    };
  }, [disabled, projectStartDate, projectEndDate]);

  return (
    <>
      <Field
        name="date_start"
        label={t("projectSchedules.fields.date_start")}
        required={required}
        className="space-y-2"
        render={({ field }) => (
          <DatePicker
            inDialog
            disabled={disabled}
            datePickerProps={{
              ...datePickerProps,
              defaultMonth: field.value
                ? parse(field.value, DEFAULT_DATE_FORMAT, new Date())
                : undefined,
            }}
            className="w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
            {...field}
          />
        )}
      />
      <Field
        name="date_end"
        label={t("projectSchedules.fields.date_end")}
        required={required}
        className="space-y-2"
        render={({ field }) => (
          <DatePicker
            inDialog
            disabled={disabled}
            datePickerProps={{
              ...datePickerProps,
              defaultMonth: field.value
                ? parse(field.value, DEFAULT_DATE_FORMAT, new Date())
                : undefined,
            }}
            className="w-full border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
            {...field}
          />
        )}
      />
    </>
  );
};

export const DateRangeField = memo(DateRangeComponent);
